import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import Header from "./Header";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import MotionWrapper from "../../../../components/MotionWrapper";

const data = [
  { id: 1, name: "dashboard" },
  { id: 2, name: "my workspace" },
  { id: 3, name: "schedules" },
  { id: 4, name: "notifications" },
];

const PermissionManagement = () => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [moduleId, setModuleId] = useState(null);
  console.log(moduleId);

  const handleClick = (e, id) => {
    const dataName = data.find((item) => item.id === id);
    if (dataName) {
      const newData = {
        moduleName: dataName.name,
        id: id,
      };
      setModuleId(newData);
    }
  };

  const handlePermission = (params) => {
    return (
      <Button
        onClick={(e) => handleClick(e, params.id)}
        sx={{
          background: "linear-gradient(to right, #a125c2, #000000)",
          color: "white",
          borderRadius: 3,
        }}
      >
        View Permissions
        <Icon
          icon="line-md:arrow-up"
          width="24"
          height="24"
          style={{ transform: "rotate(90deg)" }}
        />
      </Button>
    );
  };
  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Name", width: 300 },
    {
      field: "View Permissions",
      headerName: "View Permissions",
      width: 200,
      renderCell: handlePermission,
    },
  ];

  return (
    <Box>
      <GlobalWrapper title={"Permission Management"}>
        {moduleId ? null : (
          <Box>
            <Header />
          </Box>
        )}

        <Box>
          {moduleId ? (
            <>
              <MotionWrapper directions={"top"} delay={0.5}>
                <Typography variant="h6">
                  {moduleId?.moduleName
                    ? moduleId.moduleName.charAt(0).toUpperCase() +
                      moduleId.moduleName.slice(1)
                    : ""}
                </Typography>
              </MotionWrapper>
              <MotionWrapper directions={"right"} delay={0.5}>
                <Paper sx={{ mt: 2 }} elevation={3}>
                  <Box sx={{ width: "100%", padding: 0 }}>
                    <GlobalDatagrid
                      tableHead={columns}
                      rows={data}
                      // meta={meta?.totalRecords || 0}
                      rowUniqueId="id"
                      // loading={loading}
                      rowClick={false}
                    />
                  </Box>
                </Paper>
              </MotionWrapper>
            </>
          ) : (
            <Paper sx={{ mt: 2 }} elevation={3}>
              <Box sx={{ width: "100%", padding: 0 }}>
                <GlobalDatagrid
                  tableHead={columns}
                  rows={data}
                  // meta={meta?.totalRecords || 0}
                  rowUniqueId="id"
                  // loading={loading}
                  rowClick={false}
                />
              </Box>
            </Paper>
          )}
        </Box>
      </GlobalWrapper>
    </Box>
  );
};

export default PermissionManagement;
